import { BaseToolConfig, ToolKind } from 'shared/interfaces/tools/Tool';

export interface CollectLeadInfoToolConfig extends BaseToolConfig {
  kind: ToolKind.COLLECT_LEAD_INFO;
  toolName: ToolKind.COLLECT_LEAD_INFO;
  infoTypesToCollect: InfoType[];
  collectionAcknowledgementMessage: string;
  formTitle: string;
  labels: Partial<Record<InfoType, string>>;
  submitButtonLabel: string;
}

export type CollectLeadInfoToolConfigWithSmartAssistant = CollectLeadInfoToolConfig & { smartAssistantId: string };

export interface CollectLeadInfoToolExecutionParams {
  email?: string;
  phone?: string;
  name?: string;
}

export interface CollectLeadInfoToolExecutionDto {
  toolConfig: CollectLeadInfoToolConfigWithSmartAssistant;
  toolExecutionParams: CollectLeadInfoToolExecutionParams;
  smartAssistantId: string;
}

export enum InfoType {
  EMAIL = 'email',
  PHONE = 'phone',
  NAME = 'name',
  REASON = 'reason'
}

export const InfoTypeMapping: { [key: string]: InfoType } = {
  email: InfoType.EMAIL,
  name: InfoType.NAME,
  phone: InfoType.PHONE,
  reason: InfoType.REASON
};
